import { createFileRoute } from "@tanstack/react-router";
import { EditPrestationPage } from "@/features/achats/components/prestations/EditPrestationPage";

export const Route = createFileRoute("/_app/achats/prestations/$id/edit")({
  staticData: {
    title: "Modifier prestation",
    showInBreadcrumb: true,
  },
  component: EditPrestationPage,
});
